export const getUser = state => state.accountSetting.user;
export const getChildUser = state => state.accountSetting.childUser;
export const getMessage = state => state.accountSetting.message;
export const getIsLoading = state => state.accountSetting.isLoading;



// WEBPACK FOOTER //
// ./src/redux/selectors/accountSettingSelector.js